import { createSelector } from "reselect"
import { initialState } from "./reducer"

export const selectTwoFactorAuthActive = (state) =>
  state.get("security", initialState)

export const makeTwoFactorAuthActive = () =>
  createSelector(selectTwoFactorAuthActive, (state) => state.toJS())
